import AnchoredMenu from "./anchored-menu";

export default AnchoredMenu;
